import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'

import { TitleWithLine } from '../elements'

export const ScheduleProgramWrapper = styled.div`
  background-color: #f4f4f4;
  padding-top: 40px;
  padding-bottom: 200px;
  @media (max-width: 991px) {
    padding-bottom: 100px;
  }
`

export const ScheduleProgramContainer = styled(Container)``

export const ScheduleProgramTitle = styled(TitleWithLine)``

export const ScheduleProgramProgressBarWrapper = styled(Col)`
  @media (min-width: 768px) and (max-width: 991px) {
    padding-top: 80px;
    padding-left: 20%;
    padding-right: 20%;
  }
  @media (min-width: 576px) and (max-width: 767px) {
    padding-top: 60px;
    padding-left: 15%;
    padding-right: 15%;
  }
  @media (max-width: 575px) {
    padding-top: 60px;
  }
`

export const ScheduleProgramProgressBar = styled.div`
  position: relative;
  font-size: 18px;
  font-weight: 300;
  @media (min-width: 992px) {
    min-height: 90px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin-top: 200px;
    margin-bottom: 50px;
  }
  @media (min-width: 1200px) and (max-width: 1399px) {
    font-size: 16px;
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    font-size: 16px;
  }
  @media (max-width: 991px) {
    font-size: 12px;
  }
`

export const ScheduleProgramProgressBarImageWrapper = styled.div`
  @media (min-width: 992px) {
    display: none;
  }
  &.scheduleProgramImageDesktop {
    transform: translateY(85%);
    @media (min-width: 992px) {
      display: block;
    }
    @media (max-width: 991px) {
      display: none;
    }
  }
`

export const ScheduleProgramProgressBarTitleBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 140px;
  text-align: center;
  line-height: 1.2;
  border-radius: 10px;
  @media (min-width: 1200px) and (max-width: 1399px) {
    width: 180px;
    height: 130px;
  }
  @media (min-width: 992px) and (max-width: 1199px) {
    width: 160px;
    height: 120px;
  }
  @media (min-width: 992px) {
    transform: translateY(-100%);
  }
  @media (max-width: 991px) {
    top: auto !important;
    align-items: flex-end;
    width: 140px;
    height: auto;
    padding: 5px;
  }
  @media (min-width: 768px) and (max-width: 991px) {
  }
  @media (min-width: 576px) and (max-width: 767px) {
  }
  @media (max-width: 575px) {
    transform: translateX(-10%);
  }
  &.active {
    background-color: ${(props) => props.theme.colorWhite};
    font-weight: 700;
    box-shadow: 0 5px 20px 0 rgba(53, 121, 22, 0.19);
  }
  &.scheduleProgram {
    &.box1 {
      left: 1%;
      @media (max-width: 991px) {
        left: 8%;
        bottom: 102%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.box2 {
      left: 20%;
      @media (max-width: 991px) {
        left: 60%;
        bottom: 102%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.box3 {
      left: 36%;
      @media (max-width: 991px) {
        left: 8%;
        bottom: 52%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.box4 {
      left: 53.5%;
      @media (max-width: 991px) {
        left: 60%;
        bottom: 52%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.box5 {
      left: 70%;
      @media (max-width: 991px) {
        left: 8%;
        bottom: 8%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.box6 {
      left: 86%;
      @media (max-width: 991px) {
        left: 60.5%;
        bottom: 6.5%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
  }
  span {
    display: block;
  }
`

export const ScheduleProgramProgressBarDate = styled.div`
  position: absolute;
  left: 0;
  bottom: -25px;
  width: 150px;
  text-align: center;
  color: #91bd24;
  @media (max-width: 991px) {
    width: 140px;
  }
  @media (max-width: 575px) {
    transform: translateX(-10%);
  }
  &.active {
    color: ${(props) => props.theme.colorGreenLight};
    font-weight: 700;
  }
  &.scheduleProgram {
    &.date1 {
      left: 1%;
      @media (min-width: 992px) and (max-width: 1199px) {
        left: 4%;
      }
      @media (max-width: 991px) {
        left: 8%;
        bottom: 83%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.date2 {
      left: 21.5%;
      @media (min-width: 992px) and (max-width: 1199px) {
        left: 23%;
      }
      @media (max-width: 991px) {
        left: 60%;
        bottom: 83%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.date3 {
      left: 38%;
      @media (min-width: 992px) and (max-width: 1199px) {
        left: 43%;
      }
      @media (max-width: 991px) {
        left: 8%;
        bottom: 37%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.date4 {
      left: 55.5%;
      @media (min-width: 992px) and (max-width: 1199px) {
        left: 63.5%;
      }
      @media (max-width: 991px) {
        left: 60%;
        bottom: 37%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.date5 {
      left: 72.5%;
      @media (min-width: 992px) and (max-width: 1199px) {
        left: 83%;
      }
      @media (max-width: 991px) {
        left: 8%;
        bottom: -8%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
    &.date6 {
      left: 88.5%;
      @media (min-width: 992px) and (max-width: 1199px) {
        left: 83%;
      }
      @media (max-width: 991px) {
        left: 60.5%;
        bottom: -8%;
      }
      @media (min-width: 768px) and (max-width: 991px) {
      }
      @media (min-width: 576px) and (max-width: 767px) {
      }
      @media (max-width: 575px) {
      }
    }
  }
`

const ScheduleProgram = (props) => {
  const data = useStaticQuery(graphql`
    query {
      progressBar: file(relativePath: { eq: "teachers/progress_bar.png" }) {
        childImageSharp {
          fluid(maxWidth: 1364) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      progressBarMobile: file(
        relativePath: { eq: "teachers/progress_bar_mobile.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 720) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  return (
    <ScheduleProgramWrapper>
      <ScheduleProgramContainer>
        <Row>
          <Col>
            <ScheduleProgramTitle color="#91BD24" id="timetable">
              <span>Harmonogram programu</span>
            </ScheduleProgramTitle>
          </Col>
        </Row>
        <Row>
          <ScheduleProgramProgressBarWrapper xs={12}>
            <ScheduleProgramProgressBar className="scheduleProgram">
              <ScheduleProgramProgressBarImageWrapper className="scheduleProgramImageDesktop">
                <Img
                  fluid={data.progressBar.childImageSharp.fluid}
                  alt="Harmonogram programu"
                />
              </ScheduleProgramProgressBarImageWrapper>
              <ScheduleProgramProgressBarImageWrapper className="scheduleProgramImageMobile">
                <Img
                  fluid={data.progressBarMobile.childImageSharp.fluid}
                  alt="Harmonogram programu"
                />
              </ScheduleProgramProgressBarImageWrapper>
              <ScheduleProgramProgressBarTitleBox className="box1 scheduleProgram active">
                <span>
                  Start
                  <br />
                  programu
                </span>
              </ScheduleProgramProgressBarTitleBox>
              <ScheduleProgramProgressBarTitleBox className="box2 scheduleProgram">
                <span>
                  Dystrybucja pakietów
                  <br /> startowych
                </span>
              </ScheduleProgramProgressBarTitleBox>
              <ScheduleProgramProgressBarTitleBox className="box3 scheduleProgram">
                <span>
                  Start
                  <br />
                  konkursu
                </span>
              </ScheduleProgramProgressBarTitleBox>
              <ScheduleProgramProgressBarTitleBox className="box4 scheduleProgram">
                <span>
                  Termin nadsyłania prac
                  <br /> konkursowych
                </span>
              </ScheduleProgramProgressBarTitleBox>
              <ScheduleProgramProgressBarTitleBox className="box5 scheduleProgram">
                <span>Obrady jury</span>
              </ScheduleProgramProgressBarTitleBox>
              <ScheduleProgramProgressBarTitleBox className="box6 scheduleProgram">
                <span>
                  Ogłoszenie
                  <br /> zwycięzców
                </span>
              </ScheduleProgramProgressBarTitleBox>
              <ScheduleProgramProgressBarDate className="date1 scheduleProgram active">
                01.03.2022
              </ScheduleProgramProgressBarDate>
              <ScheduleProgramProgressBarDate className="date2 scheduleProgram">
                02.03.-30.04.2022
              </ScheduleProgramProgressBarDate>
              <ScheduleProgramProgressBarDate className="date3 scheduleProgram">
                21.03.2022
              </ScheduleProgramProgressBarDate>
              <ScheduleProgramProgressBarDate className="date4 scheduleProgram">
                31.05.2022
              </ScheduleProgramProgressBarDate>
              <ScheduleProgramProgressBarDate className="date5 scheduleProgram">
                1-3.06.2022
              </ScheduleProgramProgressBarDate>
              <ScheduleProgramProgressBarDate className="date6 scheduleProgram">
                07.06.2022
              </ScheduleProgramProgressBarDate>
            </ScheduleProgramProgressBar>
          </ScheduleProgramProgressBarWrapper>
        </Row>
      </ScheduleProgramContainer>
    </ScheduleProgramWrapper>
  )
}

export default ScheduleProgram
